import { render, staticRenderFns } from "./scientific-analysis-filter-panel.vue?vue&type=template&id=0c5436c4&scoped=true&"
import script from "./scientific-analysis-filter-panel.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-filter-panel.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-filter-panel.scss?vue&type=style&index=0&id=0c5436c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5436c4",
  null
  
)

export default component.exports